import { cn } from '@/lib/utils'
import { Link, useRouterState } from '@tanstack/react-router'
import { BookOpen, Home, Newspaper, User, Users } from '@/components/icons'

const navItems = [
  { href: '/', icon: Home, label: '홈' },
  { href: '/news', icon: Newspaper, label: '지원사업' },
  { href: '/articles', icon: BookOpen, label: '아티클' },
  { href: '/posts', icon: Users, label: '커뮤니티' },
  { href: '/mypage', icon: User, label: '마이페이지' },
] as const

export function MobileNav() {
  const routerState = useRouterState()
  const pathname = routerState.location.pathname

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-surface/80 backdrop-blur-lg sm:hidden">
      <div className="flex h-12 items-center justify-around">
        {navItems.map((item) => {
          const Icon = item.icon
          const isActive =
            pathname === item.href ||
            (item.href !== '/' && pathname.startsWith(item.href))

          return (
            <Link
              key={item.href}
              to={item.href}
              className={cn(
                'flex flex-col items-center justify-center gap-0.5 px-3 py-1.5 text-xs transition-colors',
                isActive
                  ? 'text-primary'
                  : 'text-text-muted hover:text-text',
              )}
            >
              <Icon className="h-4 w-4" />
              <span>{item.label}</span>
            </Link>
          )
        })}
      </div>
    </nav>
  )
}
